import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { PrimaryCannabinoid } from '../../../../../../../models/enum/shared/cannabinoid';
import type { PropertyPoolSorter } from '../../shared/card-data-with-property-pooling';
import { SortUtils } from '../../../../../../../utils/sort-utils';

@Injectable()
export class DougArBusinessCardStackContentViewModel extends PrintCardContentViewModel {
  private readonly pinnedSecondaryPropertyMap = new Map<string, number>([
    [PrimaryCannabinoid.THC, 0],
    [PrimaryCannabinoid.CBD, 1]
  ]);

  protected override emptyPropertyValueForPropertiesBasedOnPools(): string {
    return '-';
  }

  protected override finalSortLambdaForCompoundProperties(): PropertyPoolSorter {
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title);
  }

  protected override getSecondaryPoolOfCompoundPropertiesSortLambda(): PropertyPoolSorter {
    const defaultSort = super.getSecondaryPoolOfCompoundPropertiesSortLambda();
    return (a, b) => SortUtils.pinned(this.pinnedSecondaryPropertyMap, a?.title, b?.title) || defaultSort(a, b);
  }
}
